export const API_URL = process.env.API_URL;
export const API_KEY_3 = process.env.API_KEY_3;
export const API_KEY_4 = process.env.API_KEY_4;
export const USERNAME = process.env.USER;
export const PASSWORD = process.env.PASSWORD;
